import styled from 'styled-components';

import { UiButton } from '@/components/ui/Button';
import { UiTypography } from '@/components/ui/Typography';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const PageStyles = styled(OnboardingPage)`
  ion-content {
    background: #14111e;

    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      margin-top: 16px;
    }

    .app-logo {
      margin: 20px 0 20px;
    }
  }
`;

export const PageTitleStyles = styled(UiTypography)`
  font-weight: 900;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  text-transform: uppercase;

  .ion-page & {
    z-index: 10;
  }
`;

export const PageSubtitleStyles = styled(UiTypography)`
  .ion-page & {
    color: transparent;
  }
`;

export const BackgroundImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 2;
`;

export const MainImage = styled.img`
  position: absolute;
  z-index: 2;
  bottom: 0;
  object-fit: contain;
`;

export const MaskImage = styled.img`
  position: absolute;
  top: 25%;
  left: 0;
  z-index: 1;
`;

export const BottomButton = styled(UiButton)`
  position: fixed;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  max-width: 500px;
  height: 48px;
  padding: 0 16px;
`;
